module.exports = __webpack_public_path__ + "img/所有招标项目.c80c1792.png";